// extracted by mini-css-extract-plugin
module.exports = {"box":"box-2pIRmeww","ad":"ad-2qukkpgX"};